import { render, staticRenderFns } from "./hotelList.vue?vue&type=template&id=5bc42b20&"
import script from "./hotelList.vue?vue&type=script&lang=ts&"
export * from "./hotelList.vue?vue&type=script&lang=ts&"
import style0 from "./hotelList.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports